import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { AscentLoginNotice } from '../../ascent-login.config';

@Component({
  selector: 'app-login-notice',
  templateUrl: './login-notice.component.html',
  styleUrls: ['./login-notice.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginNoticeComponent {
  @Input() notice: AscentLoginNotice | null = null;
  @Output() dismiss = new EventEmitter<void>();
  @Output() actionClick = new EventEmitter<void>();

  get icon(): string {
    const kind = this.notice?.kind;
    if (kind === 'release' || kind === 'update') {
      return '↗';
    }
    return '!';
  }
}
